import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'
import { MARKETING_URL } from '../constants'

// `return_url` landing for the payment-setup onboarding flow (issue #206).
// Stripe sends the organizer here after they finish (or leave) Express
// onboarding. Confirmation lives in the Shoots app — held invites are released
// automatically once their Stripe account can accept payments — so this page
// just reassures them and points back into the app.
export function PaymentSetupComplete() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header variant="light" />
      <div className="container mx-auto px-4 py-16 flex-1 flex items-center justify-center">
        <div className="max-w-md w-full text-center">
          <div
            className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-[var(--color-action-primary)]/10"
            aria-hidden="true"
          >
            <svg
              className="h-7 w-7 text-[var(--color-action-primary)]"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.5}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12.75l6 6 9-13.5"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-[var(--color-text-primary)] mb-3">
            Payment setup complete
          </h1>
          <p className="text-[var(--color-text-secondary)] mb-8">
            Thanks for setting up payments. Once your account is verified, we'll
            text your guests their invites automatically, so you don't need to
            do anything else here. You can head back to the Shoots app to check
            on your event.
          </p>
          <a
            href={MARKETING_URL}
            rel="noopener noreferrer"
            className="inline-flex h-12 items-center justify-center rounded-full bg-[var(--color-action-primary)] px-6 text-base font-semibold text-white transition-colors hover:opacity-90"
          >
            Back to Shoots
          </a>
        </div>
      </div>
      <Footer />
    </div>
  )
}
